export const RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_logs =
  "/merchflows/:merchflowId/s1/:s1UserTriggerId/logs";
export interface ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_logs {
  s1_user_trigger_id: number;
  algo_request_feature_containers: unknown | null;
  algo_response_feature_containers: unknown | null;
}
